// Restricted (c) Siemens Healthineers AG, 2025, All rights reserved.

import { Injectable } from '@angular/core';
import { Observable, Subject } from 'rxjs';
import { DnaSyngoviaServerNode } from '../interfaces/dna-syngovia-node';

@Injectable({
  providedIn: 'root',
})
export class DnaSyngoviaScreenInteractionService {
  private readonly serverHealthcheckSubject =
    new Subject<DnaSyngoviaServerNode>();

  public serverHealthcheckNext(groupNode: DnaSyngoviaServerNode): void {
    this.serverHealthcheckSubject.next(groupNode);
  }

  public onServerHealthcheckChange(): Observable<DnaSyngoviaServerNode> {
    return this.serverHealthcheckSubject.asObservable();
  }
}
